import { render, staticRenderFns } from "./pembukaan.vue?vue&type=template&id=0da0bb96&scoped=true"
import script from "./pembukaan.vue?vue&type=script&lang=js"
export * from "./pembukaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0bb96",
  null
  
)

export default component.exports